/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 22nd 2021, 11:44:01 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import Drawer, { DrawerProps } from "@mui/material/Drawer";
import { useGetScreenProperties } from "lib/utils";
import DrawerMenus from "theme/components/DrawerMenus";
import { FirstSideBar } from "./FirstSideBar";

const OSDrawer = (props: DrawerProps) => {
  const { screenBreakpoint } = useGetScreenProperties();

  const drawerOpenInitialState = !["md", "sm", "xs"].includes(screenBreakpoint);

  const [drawerOpen, setDrawerOpen] = React.useState<boolean>(drawerOpenInitialState); // Initializing drawer open state

  const toggleDrawerOpen = () => setDrawerOpen(!drawerOpen);

  return (
    <div className={`app-sidebar  ${drawerOpen ? "open" : "close"}`}>
      <Drawer variant="permanent" open={drawerOpen} {...props}>
        <FirstSideBar />
        <DrawerMenus toggleDrawerOpen={toggleDrawerOpen} drawerOpen={drawerOpen} />
      </Drawer>
    </div>
  );
};

export default OSDrawer;
